import { createEditButton } from '../../../../components'
import { UpsertUserModal } from '../UpsertUser/UpsertUserModal'

export const UserEditButton = createEditButton(UpsertUserModal, 'users')
